import React from 'react';

const Streak = ({value=0, label='Streak', className=''}) => {
	return <div className={`flex flex-col items-center justify-top ${className}`}>
		<div className={'text-2xl font-gBold pb-2'}>{value}</div>
		<div className={'text-center text-sm font-gLight -mt-1 px-4'}>{label}</div>
	</div>
}

const StreakInfo = ({data=[{label:'Example', value:0}]}) => {
	return (		<div data-testid="streak-info" className={'grid grid-cols-3 gap-3 text-primary py-1 px-8 mt-2'}>
			{data?.map(({label, value}, i) => (
				<Streak key={i} value={value} label={label} className={`w-[1/${data.length}] bg-white w-full rounded-lg drop-shadow-lg`} />
			))}
		</div>
	);
};

export default StreakInfo;
